





























import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'
import RadioButton from '@/components/RadioButton.vue'
import Input from '@/components/inputs/Input.vue'

@Component({
  components: {
    Modal,
    RadioButton,
    Input
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
})
export default class RefundInvoiceModal extends Vue {
  refundAmount: string = '';
  refundType: string = 'full';

  emitRefund () {
    this.$emit('refund', {
      type: this.refundType,
      amount: this.refundAmount
    })
  }

  changeRefundType (type: string) {
    this.refundType = type
  }
}
